// extracted by mini-css-extract-plugin
export default {"span":"inputform_span__63Rpu","label":"inputform_label__IMklL","error":"inputform_error__hDAgl"};